/**
 * Motion helpers shared by the animated components.
 */

export function prefersReducedMotion() {
  if (typeof window === 'undefined' || !window.matchMedia) return true;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function hasFinePointer() {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(pointer: fine)').matches;
}

/**
 * True while scripts/prerender.js (Puppeteer) snapshots the page.
 * Animations must not leave hidden or partial states in the static HTML.
 */
export function isAutomatedBrowser() {
  return typeof navigator !== 'undefined' && Boolean(navigator.webdriver);
}

export function shouldAnimate() {
  return !prefersReducedMotion() && !isAutomatedBrowser();
}

export function easeOutCubic(t) {
  return 1 - (1 - t) ** 3;
}
